import { inject, provide, reactive, Ref, toRefs } from 'vue'
import { TopSpecialFeaturesItem } from '@/types/TopSpecialFeatures'
import { getTopSpecialFeatures } from '@/repositories/wpRestApiRepository'

interface TopSpecialFeaturesState {
  topSpecialFeatures: TopSpecialFeaturesItem[]
}

interface TopSpecialFeaturesModule {
  topSpecialFeatures: Ref<TopSpecialFeaturesItem[]>
  loadTopSpecialFeatures: () => Promise<void>
}

export const createTopSpecialFeature = (): TopSpecialFeaturesModule => {
  const state = reactive<TopSpecialFeaturesState>({
    topSpecialFeatures: []
  })

  const loadTopSpecialFeatures = async () => {
    const res = await getTopSpecialFeatures()
    state.topSpecialFeatures = res.data
  }

  return {
    ...toRefs(state),
    loadTopSpecialFeatures
  }
}

export const key = Symbol()
export const provideTopSpecialFeatures = () => {
  return provide(key, createTopSpecialFeature())
}
export const useTopSpecialFeatures = (): TopSpecialFeaturesModule => {
  return inject(key) as TopSpecialFeaturesModule
}
